import React from "react";
import ReactDOM from "react-dom";
import * as FullStory from "@fullstory/browser";
import { ThemeProvider as ThemeColorsProvider } from "styled-components";
import * as LightTheme from "@elastic/eui/dist/eui_theme_amsterdam_light.json";
import { IntlProvider } from "react-intl";
import * as DarkTheme from "@elastic/eui/dist/eui_theme_amsterdam_dark.json";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "./index.css";
import store from "./app/store";
import * as serviceWorker from "./serviceWorker";

import locale_en from "./translations/en.json";
import locale_ar from "./translations/ar.json";

import { setupRequestInterceptor, setupResponseInterceptor } from "./lib/api";

import ThemeSelector from "./modules/shared/layout/Theme/ThemeSelector";
import * as localStorage from "./lib/localStorage";

if (process.env.NODE_ENV === "production") FullStory.init({ orgId: "XNCS9" });

setupResponseInterceptor(store);
setupRequestInterceptor(store);

const isDarkTheme = localStorage.getItem("theme") === "dark";
const lang = localStorage.getItem("locale");

const messages = {
    ar: locale_ar,
    en: locale_en,
};

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <ThemeColorsProvider theme={isDarkTheme ? DarkTheme : LightTheme}>
                    <ThemeSelector>
                        <IntlProvider
                            locale={lang}
                            messages={messages[lang]}
                        >
                            <App />
                        </IntlProvider>
                    </ThemeSelector>
                </ThemeColorsProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
